import { lazy } from "react";

export const UploadPhotoFormAsync = lazy(() => import("./UploadPhotoForm"));
